import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ResolvedEmailsPage } from '@features/admin/resolved-emails';
import { useAdminResolvedEmailStore } from '@features/admin/resolved-emails/useAdminResolvedEmailStore.ts';

const adminResolvedEmailsSearchSchema = z.object({
  search: z.string().optional(),
  status: z.enum(['PENDING', 'SENDING', 'SENT', 'FAILED', 'SKIPPED']).optional(),
  organizationId: z.coerce.number().optional(),
  page: z.coerce.number().optional().default(1),
  size: z.coerce.number().optional().default(20),
});

export type AdminResolvedEmailsSearch = z.infer<typeof adminResolvedEmailsSearchSchema>;

export const Route = createFileRoute('/admin/resolved-emails/')({
  validateSearch: search => adminResolvedEmailsSearchSchema.parse(search),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { search, status, organizationId, page, size } = ctx.search;
    useAdminResolvedEmailStore.getState().loadResolvedEmails({
      search,
      status,
      organizationId,
      page: page || 1,
      size: size || 20,
    });
  },
});

function RouteComponent() {
  return <ResolvedEmailsPage />;
}
